export default __webpack_public_path__ + "static/media/PAFI_Risalah RUPS_Minutes of GMS 2021.bc013e13.pdf";